window.AS = window.AS || {}